if (!customElements.get('ls-gallery-dots')) {
  customElements.define(
    'ls-gallery-dots',
    class LsGalleryDots extends HTMLElement {
      connectedCallback() {
        const gallery = this.closest('media-gallery');
        const thumbnails = gallery ? gallery.querySelectorAll('.thumbnail-list__item .thumbnail') : [];
        if (thumbnails.length < 2) return;

        thumbnails.forEach(() => this.appendChild(document.createElement('span')).className = 'ls-gallery-dot');
        this.dots = this.querySelectorAll('.ls-gallery-dot');

        this.sync = () => {
          thumbnails.forEach((thumbnail, index) => {
            this.dots[index].classList.toggle('is-active', thumbnail.getAttribute('aria-current') === 'true');
          });
        };

        this.sync();
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(gallery, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}

/* ---------------------------------------------------------------------------
   Desktop arrow navigation for PDP gallery (thumbnail layout)
   On mobile the SliderComponent handles prev/next natively via scroll.
   On desktop (≥750px, thumbnail layout) the slider is not active — clicks
   on prev/next do nothing. This listener intercepts them and clicks the
   adjacent thumbnail instead, which triggers Dawn's MediaGallery to swap
   the active media.
   --------------------------------------------------------------------------- */
(function () {
  function initArrows(gallery) {
    const prevBtn = gallery.querySelector('.ls-pdp-main-arrows__btn--prev');
    const nextBtn = gallery.querySelector('.ls-pdp-main-arrows__btn--next');
    if (!prevBtn || !nextBtn) return;

    function getThumbs() {
      return Array.from(gallery.querySelectorAll('.thumbnail-list__item .thumbnail'));
    }

    function getActiveIndex(thumbs) {
      const idx = thumbs.findIndex(t => t.getAttribute('aria-current') === 'true');
      return idx === -1 ? 0 : idx;
    }

    function updateDisabled(thumbs, activeIdx) {
      prevBtn.disabled = activeIdx === 0;
      nextBtn.disabled = activeIdx === thumbs.length - 1;
    }

    function navigate(direction) {
      // On mobile the SliderComponent handles this — skip
      if (window.innerWidth < 750) return;

      const thumbs = getThumbs();
      if (!thumbs.length) return;

      const activeIdx = getActiveIndex(thumbs);
      const targetIdx = direction === 'prev'
        ? Math.max(0, activeIdx - 1)
        : Math.min(thumbs.length - 1, activeIdx + 1);

      if (targetIdx !== activeIdx) thumbs[targetIdx].click();

      updateDisabled(thumbs, targetIdx);
    }

    prevBtn.addEventListener('click', () => navigate('prev'));
    nextBtn.addEventListener('click', () => navigate('next'));

    // Initial disabled state
    const thumbs = getThumbs();
    if (thumbs.length) updateDisabled(thumbs, getActiveIndex(thumbs));

    // Keep disabled state in sync when thumbnail changes
    const observer = new MutationObserver(() => {
      const t = getThumbs();
      updateDisabled(t, getActiveIndex(t));
    });
    observer.observe(gallery, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
  }

  // Init for all media-gallery elements on the page
  document.querySelectorAll('media-gallery').forEach(initArrows);
})();
